"use client";
import ImageWrapper from "@/components/ImageWrapper";
import { sendSalesforceInteraction } from "@/helpers/cdnSdk";
import { addDataLayer } from "@/helpers/dataLayer";
import { getUTMParameter } from "@/helpers/getUTMParameters";
import { CDP_EVENTS } from "@/utils/constant";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import Link from "@/components/Link";
import React from "react";

export default function HeaderLogo({ headerData, setIsPanelOpen }: any) {
  const { uid: Uid } = useAppSelector(
    (state) => state.gigyaslice
  );
  return (
    <Link
      className=""
      aria-label={"Sobeys Logo"}
      href="/"
      onClick={() => {
        // setIsPanelOpen(false);
        addDataLayer({
          event: "nav_header",
          click_text: process.env.NEXT_PUBLIC_DEFAULT_BANNER,
          click_url: process?.env?.NEXT_PUBLIC_BASE_URL,
          page_title: document.title
        });
        sendSalesforceInteraction({
          name: "nav_click",
          banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
          clickText: "Sobeys",
          clickUrl: process.env.NEXT_PUBLIC_BASE_URL,
          screenClass: window?.location?.href,
          screenName: document.title,
          isAnonymous: Uid ? 0 : 1,
          gigyaUid: Uid,
          utmSource: getUTMParameter("utm_source"),
          utmMedium: getUTMParameter("utm_medium"),
          utmCampaign: getUTMParameter("utm_campaign"),
        });
      }}
    >
      <ImageWrapper
        src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${headerData?.logoImage || ""}`}
        alt={headerData?.logoalt || "Sobeys Logo"}
        height={48}
        width={98}
      />
    </Link>
  );
}
